import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { doc, DocumentReference, Firestore, docData } from '@angular/fire/firestore';
import { firstValueFrom, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmotesService {

  cmsUrl = '';

  constructor(public http: HttpClient, private firestore: Firestore) {
      this.cmsUrl = environment.cmsUrl;
  }

  getEmotesList() {
      const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };

      return firstValueFrom(this.http
          .get<any>(this.cmsUrl + 'emojis/all', httpOptions)
          .pipe(filter((data) => data != null || data !== undefined)));
  }

  public getUserEmoteCount(uid: string): Observable<{ emoji_count?: number } | undefined> {
      const ref = doc(this.firestore, `users/${uid}/emotes/emote`) as DocumentReference<{ emoji_count?: number }>;
      return docData(ref);
  }
}
